<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>
        <custom-table-list :options="entity"
                           :fields="fields"
                           placeholder-search="Поиск категории MML"
                           edit-link="/Admin/MmlCategories/Edit" />
    </div>
</template>
<script>
import AllRoutes from '@/routes/all.routes'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import CustomTableList from '@/components/shared/CustomTableList'

import Consts from '@/store/models/consts/adminConsts'
export default {
    data: function() {
        let load = new Loading();

        this.getAll(load);

        return {
            load: load,
            entity: null,
            fields: [
                {
                    key: 'Name',
                    label: 'Наименование',
                    sortable: true,
                }, 
                {
                    key: 'SubType',
                    label: 'Тип'
                },
                {
                    key: 'Code',
                    label: 'Код сегмента',
                    formatter: (value) => {
                        return Consts.SegmentCodes.find(e => e.Id == value).Text;
                    }
                }
            ]
        }
    },
    methods: {
        getAll: function(load) {
            load.Calculate(true);

            apiService.Admin.MmlCategories.GetAll()
                .then(response => {
                    this.entity = response.data;
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        }
    },
    components: {
        Spinner,
        CustomTableList
    }
}
</script>